<template>
  <tooltip>
    <template
      #trigger="{ toggle, isShowing }"
      @hide="$emit('hide')"
      @show="$emit('show')"
    >
      <div
        class="relative search-input-wrapper flex items-center cursor-pointer"
        @click="toggle"
      >
        <input
          readonly
          type="text"
          class="search-input w-full"
          :value="selectedItem.title"
        />

        <svg
          width="20"
          height="20"
          class="flex-none search-icon text-black-light-5"
          fill="currentColor"
        >
          <use :xlink:href="selectedItem.icon"></use>
        </svg>

        <svg
          width="20"
          height="20"
          fill="currentColor"
          class="right-icon text-black-light-5"
        >
          <use
            v-if="!isShowing"
            xlink:href="/img/sprite.svg#ic_chevron-down"
          ></use>
          <use v-else xlink:href="/img/sprite.svg#ic_chevron-up"></use>
        </svg>
      </div>
    </template>

    <template #default="{ hide }">
      <ul
        class="list-reset bg-white px-4 text-left mdsm:w-full mdsm:py-2 rounded-b"
      >
        <li
          class="flex items-start py-4 mb-0"
          v-for="item in availableProducts"
          :key="item.value"
          @click="onSelect(item.value, hide)"
        >
          <div
            class="icon flex items-center justify-center text-secondary mr-2"
          >
            <svg width="20" height="20" fill="currentColor">
              <use :xlink:href="item.icon"></use>
            </svg>
          </div>
          <div class="text">
            <div class="leading-6">{{ item.title }}</div>
          </div>
        </li>
      </ul>
    </template>
  </tooltip>
</template>

<script>
import Tooltip from "../../core/Tooltip";

export default {
  components: {
    Tooltip,
  },
  props: ["value"],
  data() {
    return {
      productAvailability: {},
    };
  },
  computed: {
    selectedItem() {
      const item = this.availableProducts.find((o) => o.value === this.value);

      if (item) {
        return item;
      }

      if (this.availableProducts.length) {
        return this.availableProducts[0];
      }

      return {
        title: "Resorts",
        subTitle: "Stay and dive from a land-based resort",
        icon: "/img/sprite.svg#ic_resort",
        value: "resort",
      };
    },
    availableProducts() {
      const options = [];

      if (this.productAvailability.hasResorts) {
        options.push({
          title: "Resorts",
          subTitle: "Stay and dive from a land-based resort",
          icon: "/img/sprite.svg#ic_resort",
          value: "resort",
        });
      }
      if (this.productAvailability.hasLiveaboards) {
        options.push({
          title: "Liveaboards",
          subTitle: "Cruise and dive the best spots in the region",
          icon: "/img/sprite.svg#ic_boat",
          value: "liveaboard",
        });
      }
      if (this.productAvailability.hasYachts) {
        options.push({
          title: "Charter Yachts",
          subTitle: "Book a private boat expedition",
          icon: "/img/sprite.svg#ic_charter-yacht",
          value: "yacht",
        });
      }
      /*
      if (this.productAvailability.hasEcoventures) {
        options.push({
          title: "Ecoventures",
          subTitle: "Choose a positive ocean-impact experience",
          icon: "/img/sprite.svg#ic_ecoventure",
          value: "ecoventure",
        });
      }
        */

      if (options.length === 0) {
        return [
          {
            title: "Resorts",
            subTitle: "Stay and dive from a land-based resort",
            icon: "/img/sprite.svg#ic_resort",
            value: "resort",
          },
          {
            title: "Liveaboards",
            subTitle: "Cruise and dive the best spots in the region",
            icon: "/img/sprite.svg#ic_boat",
            value: "liveaboard",
          },
          /*
          {
            title: "Ecoventures",
            subTitle: "Choose a positive ocean-impact experience",
            icon: "/img/sprite.svg#ic_ecoventure",
            value: "ecoventure",
          },
          */
          {
            title: "Charter Yachts",
            subTitle: "Book a private boat expedition",
            icon: "/img/sprite.svg#ic_charter-yacht",
            value: "yacht",
          },
        ].filter((opt) => opt.value === window.zubluSearchType);
      }

      return options;
    },
  },
  methods: {
    fetchProductAvailability(destinationId) {
      const craftAPIEndpoint = Number.isSafeInteger(Number(destinationId))
        ? "zuBlu/public/getDestinationStructure"
        : "zuBlu/public/getDestinationStructureByCode";

      $.ajax({
        method: "POST",
        url: "/",
        data: {
          id: destinationId,
          destination_id: destinationId,
          action: craftAPIEndpoint,
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((structure) => {
          const url = `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v2/products_availability_query`;
          const payload = {
            destination_structure: JSON.parse(structure),
          };

          return $.post(url, payload);
        })
        .then((availability) => {
          this.productAvailability = availability;
        });
    },
    onSelect(val, hide) {
      this.$emit("input", val);

      hide();
    },
  },
  watch: {
    selectedItem(item) {
      this.$emit("input", item.value);
    },
  },
};
</script>

<style scoped>
.search-input-wrapper .right-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  fill: var(--black-light-5);
}
</style>
